import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {getFloatingChatRuntimeConfig} from './floating-chat.runtime';

export interface FloatingChatMessage {
  user: string;
  message: string;
  time: string;
}

export interface FloatingChatHistoryResponse {
  userName: string | null;
  tel: string | null;
  messages: FloatingChatMessage[];
}

export interface FloatingChatSendRequest {
  sessionId: string;
  name: string;
  tel: string;
  message: string;
}

export interface FloatingChatSendResponse {
  status: string;
  message: string;
}

@Injectable({providedIn: 'root'})
export class FloatingChatService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = getFloatingChatRuntimeConfig().apiUrl ?? '/api/chat';

  getHistory(sessionId: string): Observable<FloatingChatHistoryResponse> {
    return this.http.get<FloatingChatHistoryResponse>(this.apiUrl, {params: {sessionId}});
  }

  sendMessage(payload: FloatingChatSendRequest): Observable<FloatingChatSendResponse> {
    return this.http.post<FloatingChatSendResponse>(`${this.apiUrl}/messages`, payload);
  }
}
